module.exports = __webpack_public_path__ + "img/MG_4621-scaled.352b9368.jpg";